import { Tag } from 'antd';

import { BadgeStatusEnum, WaitingListStatusEnum } from '@seaters/constants';
import { errorColor, successColor } from '@seaters/ui';

export interface BadgeStatusTagProps {
  status: BadgeStatusEnum | WaitingListStatusEnum;
}

const badgeStatusToColor: Record<string, string> = {
  [BadgeStatusEnum.ARCHIVED]: errorColor,
  [BadgeStatusEnum.ACTIVE]: successColor,
};
export function WishListBadgeStatusTag({ status }: BadgeStatusTagProps) {
  return <Tag color={badgeStatusToColor[status]}>{status}</Tag>;
}

export default WishListBadgeStatusTag;
